/**
 * Created by mohameds on 8/7/19.
 */
import {MONITOR_HEADER_SETTINGS, ALL_USERS, ALL_PAGES,
  ALL_PAGE_POSITION,
  ALL_KPIS,
  ADD_TO_PAGE_POSITION,
  DELETE_PAGE_POSITION,
  GET_PAGE_DATA,
  SET_INDIVIDUAL_PAGE_DATA,
  UPDATE_APP_VERSION,
  AGENCY_PL_PROFILE,
  FIRST_TIME_RELOAD
} from './../actions/ActionTypes';
import InitialState from './InitialState';
import {setUser, getUser, setReloadFlag, getReloadFlag} from '../utils/TokenManager';
import {isEmpty} from 'lodash'

const AgencyMonitorReducer = (state = InitialState.agencyMonitor, action) => {
  switch (action.type) {
    case MONITOR_HEADER_SETTINGS: {
      return {
        ...state,
        headerSettings: action.headerData,
      };
    }

    case ALL_USERS: {
      return {
        ...state,
        userData: action.userData,
      };
    }

    case ALL_PAGES: {
      return {
        ...state,
        pageData: action.pageData,
      };
    }

    case ALL_PAGE_POSITION: {
      return {
        ...state,
        pagePositionData: action.pagePosition,
      };
    }

    case ALL_KPIS: {
      return {
        ...state,
        kpis: action.kpis,
      };
    }

    case ADD_TO_PAGE_POSITION: {
      const filteredKeys = ['id', 'monitor_page_type', 'page_type', 'title'];
      const filtered = filteredKeys
        .reduce((obj, key) => ({ ...obj, [key]: action.data[key] }), {});
      return {
        ...state,
        pagePositionData: [...state.pagePositionData, filtered]
      };
    }

    case DELETE_PAGE_POSITION: {
      const pagePositionData = state.pagePositionData.filter(item => item.id !== action.pageId);
      return {
        ...state,
        pagePositionData
      };
    }

    case GET_PAGE_DATA : {
      let pagePosition = state.pagePositionData.map(x => x.id === action.pageData.id ?  action.pageData : x);
      if(!isEmpty(action.prevData)){
        pagePosition = state.pagePositionData.map(x => x.id === action.prevData.id ?  action.prevData : x);
      }
      return {
        ...state,
        pageSettingsData: action.pageData,
        pagePositionData: pagePosition
      };
    }

    case SET_INDIVIDUAL_PAGE_DATA: {
      return {
        ...state,
        individualPageData: action.pageData
      }
    }

    case UPDATE_APP_VERSION: {
      const userData  = getUser()
      userData['app-version'] = action.version;
      setUser(userData);
      return state;
    }

    case AGENCY_PL_PROFILE: {
      return {
        ...state,
        agencyProfiles: action.profileList
      };
    }

    case FIRST_TIME_RELOAD: {
      const flag = getReloadFlag();
      if(flag === 'true') {
        setReloadFlag(false);
      } else {
        setReloadFlag(true);
        window.location.reload(true);
      }
      return state;
    }

    default:
      return state;
  }
};
export default AgencyMonitorReducer;


// WEBPACK FOOTER //
// ./src/reducers/AgencyMonitorReducer.js